import React, { useEffect, useState } from "react";

import axios from "axios";
import { Row, Col, Button } from "react-bootstrap";

import RegistrarCita from "../registroControl/RegistrarCita";
import RegistrarPrimeraCita from "../registroControl/RegistrarPrimeraCita";
import RegistrarAcompaniante from "./RegistrarAcompaniante";
import Acompaniante from "./Acompaniante";
import Paciente from "./Paciente";
import PrimeraCita from "./PrimeraCita";
import Cita from "./Cita";
import Repertorizacion from "./Repertorizacion";

import "../../../css/pacientes.css";

const PacienteDetail = (props) => {
  const [paciente, setPaciente] = useState(null);
  const [update, setUpdate] = useState(true);
  const [imprimirUltimoControl, setImprimirUltimoControl] = useState(false);
  const { id } = props.match.params;

  const fetchData = async () => {
    const result = await axios.get(`/api/paciente/${id}`);
    setPaciente(result.data);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [update]);

  useEffect(() => {
    if (imprimirUltimoControl === true) {
      // Wait for browser to paint the updated DOM
      setTimeout(() => {
        window.print();
        // Reset the state afterwards
        setImprimirUltimoControl(false);
      }, 0);
    }
  }, [imprimirUltimoControl]);

  const handleImprimirInformacionPaciente = () => {
    setImprimirUltimoControl(false);
    setTimeout(() => window.print(), 0);
  };

  const handleImprimirUltimoControl = () => {
    setImprimirUltimoControl(true);
  };

  if (paciente) {
    return (
      <div className="container py-3">
        <Row>
          <Col className="d-flex justify-content-center">
            <div className="hide-on-print">
              <Button
                style={{
                  backgroundColor: "#F5E6D3",
                  borderColor: "#F5E6D3",
                  color: "#000000",
                }}
                onClick={handleImprimirInformacionPaciente}
              >
                Imprimir información del paciente
              </Button>
            </div>
          </Col>
          <Col className="d-flex justify-content-center">
            <div className="hide-on-print">
              <Button
                style={{
                  backgroundColor: "#F5E6D3",
                  borderColor: "#F5E6D3",
                  color: "#000000",
                }}
                onClick={handleImprimirUltimoControl}
              >
                Imprimir último control del paciente
              </Button>
            </div>
          </Col>
        </Row>
        <Row>
          <Paciente data={paciente} />
        </Row>
        <div className="hide-on-print">
          <Row>
            <Col xs={12}>
              <h2>Acompañante</h2>
            </Col>

            <hr />
            <Col xs={12}>
              {paciente.acompaniante.length > 0 ? (
                <Acompaniante data={paciente.acompaniante[0]} />
              ) : (
                <RegistrarAcompaniante
                  id={id}
                  update={update}
                  setUpdate={setUpdate}
                />
              )}
            </Col>
          </Row>
        </div>
        <Row>
          <Col xs={12}>
            <h2>Registros</h2>
          </Col>
          <hr />
          <Col xs={12}>
            {paciente.primeraCita.length > 0 ? (
              <>
                <div className="hide-on-print">
                  <RegistrarCita
                    id={id}
                    update={update}
                    setUpdate={setUpdate}
                  />
                  <hr />
                </div>
                <div className={imprimirUltimoControl && "hide-on-print"}>
                  <PrimeraCita
                    data={paciente.primeraCita[0]}
                    esHombre={paciente.sexo === "Masculino"}
                  />
                  <hr />
                </div>
              </>
            ) : (
              <div className="hide-on-print">
                <RegistrarPrimeraCita
                  id={id}
                  ginecologia={paciente.sexo !== "Masculino"}
                  update={update}
                  setUpdate={setUpdate}
                />
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={8} lg={9}>
            {paciente.citas.map((cita) => {
              return (
                <div key={cita._id}>
                  <Cita data={cita} />
                  <hr />
                </div>
              );
            })}
          </Col>
          <Col xs={12} md={4} lg={3}>
            {paciente.repertorizaciones.map((rep) => {
              return (
                <div className="hide-on-print" key={rep._id}>
                  <Repertorizacion data={rep} />
                  <hr />
                </div>
              );
            })}
          </Col>
        </Row>
      </div>
    );
  }
  return <div>Cargando...</div>;
};

export default PacienteDetail;
